import React, {Component} from 'react';
import {Tree, Spin} from 'antd';

const TreeNode = Tree.TreeNode;
export default class TreeControl extends Component {
    state = {
        treeData: []
    }
    createHtml = str => ({__html: str ? str : `&nbsp;`});

    render() {
        const {treeData, handleTreeCheck, loading = false, disableCheckbox = false, checkable = true, checkStrictly = true, handleTreeSelect} = this.props;
        const loop = data => data.map((item) => {
            if (item.list) {
                return (
                    <TreeNode key={item.id} disableCheckbox={disableCheckbox} title={<div title={item.name}
                                                                                          dangerouslySetInnerHTML={{__html: item.question_count === undefined ? item.name : `${item.name}<span style="color: #42bda4;margin-left: 10px;"">总题数：</span><span style="color: #0d84c3;">${item.question_count}</span> <span style="color: #42bda4;margin-left: 10px;">打标签数：</span><span style="color: #0d84c3;">${item.question_count_select}</span><span style="color: #42bda4;margin-left: 10px;">返工数：</span><span style="color: #0d84c3;">${item.question_count_checkrework}</span>`}}/>}>
                        {loop(item.list)}
                    </TreeNode>
                );
            }
            return <TreeNode key={item.id}
                             title={<div title={item.name} dangerouslySetInnerHTML={this.createHtml(item.name)}/>}/>;
        });


        return (
            <Spin spinning={loading}>
                {
                    !loading &&
                    <Tree
                        onCheck={handleTreeCheck}
                        checkable={checkable}
                        checkStrictly={checkStrictly}
                        onSelect={handleTreeSelect}
                    >
                        {loop(treeData || [])}
                    </Tree>
                }
                {
                    treeData && treeData.length < 1 &&
                    <div style={{marginTop:10}}>
                        无数据
                    </div>
                }
            </Spin>
        );
    }
}



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/set_tag/tag_task_list/creat_task/TreeControl.js